import type { VideoEmbedKind } from './types'

// Pure URL-shape helpers ported verbatim from OrphexPreviewVideo.vue:63–96. They carry no
// report-domain knowledge (that lived in OrphexPreviewMedia.vue / OrphexChart.js, out of scope):
// they only classify a URL and build an embed URL, so they belong with the media primitives.

const DIRECT_VIDEO_EXTENSION = /\.(?:mp4|webm|ogg|mov)(?:\?|$)/i
const DIRECT_VIDEO_HOSTS = [
  'fbcdn.net',
  'scontent-',
  'storage.googleapis.com',
  'amazonaws.com',
  'tiktokcdn.com',
  'tiktok.com',
]

export function resolveVideoType(url: string | undefined): VideoEmbedKind {
  if (!url) return 'image'
  if (url.includes('facebook.com/') && url.includes('/videos/')) return 'facebook'
  if (url.includes('youtube.com') || url.includes('youtu.be')) return 'youtube'
  if (DIRECT_VIDEO_EXTENSION.test(url) || DIRECT_VIDEO_HOSTS.some((host) => url.includes(host))) {
    return 'direct'
  }
  return 'image'
}

export function getYoutubeEmbedUrl(url: string | undefined): string {
  if (!url) return ''
  let videoId = ''
  if (url.includes('youtube.com/watch?v=')) {
    const match = /[?&]v=([^&]+)/.exec(url)
    videoId = match?.[1] ?? ''
  } else if (url.includes('youtu.be/')) {
    const match = /youtu\.be\/([^?&]+)/.exec(url)
    videoId = match?.[1] ?? ''
  }
  return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : ''
}

export function getFacebookEmbedUrl(url: string | undefined): string {
  if (!url) return ''
  return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=0&width=560&autoplay=true`
}
